import { Badge } from '@cocoonspace/ui/components/badge'
import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'
import { MapPinIcon, VideoIcon } from 'lucide-react'

export const OnsiteBadge = ({ className }: { className?: string }) => {
	const { t } = useLingui()

	return (
		<Badge
			variant='error'
			size='sm'
			className={cn('gap-1 self-start', className)}
		>
			<MapPinIcon className='!size-3' />
			{t`Présentiel`}
		</Badge>
	)
}

export const RemoteBadge = ({ className }: { className?: string }) => {
	const { t } = useLingui()

	return (
		<Badge
			variant='secondary'
			size='sm'
			className={cn('gap-1 self-start', className)}
		>
			<VideoIcon className='!size-3' />
			{t`Distanciel`}
		</Badge>
	)
}
